import { TFunction } from "i18next";
import { APP_NAME } from "../../utls/constants";

interface IProfileCustomPageInfos {
    username: string;
    t: TFunction<"translation", undefined>;
}

const useProfileCustomPageInfos = ({ username, t }: IProfileCustomPageInfos) => {
    const pageTitle = `${username} ${APP_NAME}`;
    const pageDescription = t("profile_description", { username, appName: APP_NAME }) || "";

    document.title = pageTitle;
    
    let metaDescription = document.querySelector('meta[name="description"]') as HTMLMetaElement;
    if (!metaDescription) {
        metaDescription = document.createElement("meta");
        metaDescription.name = "description";
        document.head.appendChild(metaDescription);
    }
    metaDescription.content = pageDescription;

    let linkCanonical = document.querySelector('link[rel="canonical"]') as HTMLLinkElement;
    if (!linkCanonical) {
        linkCanonical = document.createElement("link");
        linkCanonical.rel = "canonical";
        document.head.appendChild(linkCanonical);
    }
    linkCanonical.href = `https://www.twizz.app/@${username}`;

    let metaRobots = document.querySelector('meta[name="robots"]') as HTMLMetaElement;

    if (!metaRobots) {
        metaRobots = document.createElement("meta");
        metaRobots.name = "robots";
        document.head.appendChild(metaRobots);
    }
    metaRobots.content = "index, follow, noimageindex";

    let scriptJsonLd = document.querySelector('script[type="application/ld+json"]') as HTMLScriptElement;
    if (!scriptJsonLd) {
        scriptJsonLd = document.createElement("script");
        scriptJsonLd.type = "application/ld+json";
        document.head.appendChild(scriptJsonLd);
    }
    scriptJsonLd.textContent = JSON.stringify({
        "@context": "https://schema.org",
        "@type": "ProfilePage",
        "name": username,
        "url": `https://www.twizz.app/@${username}`
    });

    return () => {
        document.title = APP_NAME;
        if (metaDescription) {
            metaDescription.content = "";
        }
        if (linkCanonical) {
            linkCanonical.remove();
        }
        if (metaRobots) {
            metaRobots.content = "";
        }
        if (scriptJsonLd) {
            scriptJsonLd.remove();
        }
    };
};

export default useProfileCustomPageInfos;